
export const forceNoMargin = () => {
  const body = document.querySelector('body');
  if (body)
    body.style.margin = '0';
}